import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { PaymentDetailsModal, Title } from "../../Components/Atoms";
import { getOrderDetails, getShipmentDetails, markInstallationComplete } from "../../APIs";
import { getLocalisedDate, getLocalisedTime } from "../../Library/datetime";
import { Button, Checkbox } from "@chakra-ui/react";
import { VideoIcon, VerifiedIcon } from "../../Assets/images/svgs";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PATHS from "../../Routes/paths";
import {ORDER_STATUS_CANCELLED, ORDER_STATUS_VALS as ORDER_STATUS_VALS_NEW, ORDER_TIMELINE_STATUSES as ORDER_TIMELINE_STATUSES_NEW, SELLER_DES, DEVICE_INSTALLATION_TIMELINE_STATUSES, DEVICE_INSTALLATION_TIMELINE_STATUSES_VAL, ORDER_STATUS_PAYMENT_DONE, ORDER_STATUS_PI_RAISED, DEV_INSTALLATION_STEPS, PING_TEST_STATUS_VAL, SHIPMENT_STATUSES, SHIPMENT_STATUSES_VAL, SUBDEALERS_DES, SHIPMENT_STATUS_CANCELLED, RELAY_TEST_STATUS_VAL } from "../../Library/constants";
import AddPayment from "../../Pages/Payments/addPaymentModal";


const orderDetailKeysAndLabels = [
  { label: "Order ID", key: "orderId" },
  { label: "Quantity", key: "devcnt" },
  // { label: "Amount", key: "transc", nestedKey: "amt" },
  // { label: "Dealer", key: "dnm" },
];

const LastOrder = ({ showOrderDetails = true, isOverviewPage = false, orderId , isInstallationDetails=false, installationDetails={}, handleMapDevice, handlePerformPingTest, checkIfPingTestIsCompleted, title, isShipmentTimeLine=false, isShipmentOverviewPage=false, recentOrderData, shipmentData }) => {
  const [ orderDetails, setOrderDetails ] = useState(recentOrderData || {});
  const [ isCancelledOrder, setIsCancelledOrder ] = useState(false);
  const [ isPiRaised, setIsPiRaised ] = useState(false);
  const orderStatusesRef = useRef({});
  const INV_PREFIX = useRef("");
  const navigate = useNavigate();
  const location = useLocation();

  const installationStatusRef = useRef({});
  const shipmentStatusRef = useRef({});
  const [shipmentDetails, setShipmentDetails] = useState(shipmentData || {});
  const [ searchParams ] = useSearchParams();
  const imeiRef = useRef(searchParams.get("imei"));
  const isShipment = useRef(!!searchParams.get("shipId"));
  const [isDeviceInstalled, setIsDeviceInstalled] = useState(false);
  const [isPingTested, setIsPingTested] = useState(false);
  const [isRelayTested, setIsRelayTested] = useState(false);
  const [isDeviceMapped, setIsDeviceMapped] = useState(false);
  const [instTimelineHasData, setInstTimelineHasData] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [isAddPaymentModalVisible, setIsAddPaymentModalVisible] = useState(false);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [isPaymentDetailAvailable, setIsPaymentDetailAvailable] = useState(false);

  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  const isSeller = DESIGNATION === SELLER_DES;
  let ORDER_TIMELINE_STATUSES={};
  let ORDER_STATUS_VALS={};

  let SHOW_RELAY_TEST_BTN = window.localStorage.getItem("relay");
  if (SHOW_RELAY_TEST_BTN) {
    try {
      SHOW_RELAY_TEST_BTN = JSON.parse(SHOW_RELAY_TEST_BTN);
    } catch (e){
      if (e) SHOW_RELAY_TEST_BTN = false;
    }
  }

  if(!isSeller){
    const omit = [1.1];
    ORDER_TIMELINE_STATUSES = ORDER_TIMELINE_STATUSES_NEW.filter((status)=> !omit.includes(status.idx));
    ORDER_STATUS_VALS = Object.keys(ORDER_STATUS_VALS_NEW)
      .filter(key => !omit.includes(parseFloat(key)))
      .reduce((acc,key)=>(acc[key]=ORDER_STATUS_VALS_NEW[key],acc),{})
  } else{
    ORDER_TIMELINE_STATUSES = ORDER_TIMELINE_STATUSES_NEW;
    ORDER_STATUS_VALS = ORDER_STATUS_VALS_NEW;
  }

  const onOrderStatusUpdate = (status) => {
    if (DESIGNATION === SUBDEALERS_DES || isShipmentTimeLine) {
      shipmentStatusRef.current[status.stat] = status;

      setShipmentDetails(prevShipmentDetails => ({
        ...prevShipmentDetails,
        os: [...prevShipmentDetails.os, status],
      }));
    } else {
      orderStatusesRef.current[status.stat] = status;

      setOrderDetails(prevOrderDetails => ({
        ...prevOrderDetails,
        os: [...prevOrderDetails.os, status],
      }));
    }

    setIsCancelledOrder(status.stat === ORDER_STATUS_CANCELLED);
  };

  const processAndStoreRecentOrder = (order) => {
    if (!order || !order.orders || !order.orders.length) return console.error("no orders found");

    if (order.prefix) INV_PREFIX.current = order.prefix;

    order = order.orders[0];
    order.os.forEach(status => {
      orderStatusesRef.current[status.stat] = status;

      if (status.stat === ORDER_STATUS_CANCELLED) setIsCancelledOrder(true);
      else if (status.stat === ORDER_STATUS_PI_RAISED) setIsPiRaised(true);
    });

    setOrderDetails(order);
  }

  const processAndStoreShipmentData = (data) => {
    if (data.orders && data.orders.length) {
      if (data.orders[0].os && data.orders[0].os.length) {
        data.orders[0].os.forEach(status => {
          shipmentStatusRef.current[status.stat] = status;
        });
      }
      setShipmentDetails(data.orders[0]);
    }
  }

  useEffect(() => {
    if(isShipmentTimeLine){
      if (shipmentDetails && shipmentDetails.orders && shipmentDetails.orders.length) {
        processAndStoreShipmentData(shipmentDetails);
      } else {
        getShipmentDetails(orderId, null, !orderId, (err, data) => {
          if (err) console.error(err);
          else processAndStoreShipmentData(data);
        });
      }
    } else {
      if (orderDetails && orderDetails.orders && orderDetails.orders.length) {
        processAndStoreRecentOrder(orderDetails);
      } else {
        if (DESIGNATION === SELLER_DES) {
          getOrderDetails(orderId || null, null, orderId ? null : true, (err, order) => {
            if (err) console.error(err);
            else processAndStoreRecentOrder(order);
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    const { instTs, ptStat, ptTs, relayStat, relayTs, mapTs } = installationDetails || {};

    if (mapTs) {
      installationStatusRef.current[DEV_INSTALLATION_STEPS.DEVICE_MAPPING] = { stat: DEV_INSTALLATION_STEPS.DEVICE_MAPPING, ts: mapTs};
      setIsDeviceMapped(!!mapTs);
    }
    if (instTs) {
      installationStatusRef.current[DEV_INSTALLATION_STEPS.DEVICE_INSTALLATION] = { stat: DEV_INSTALLATION_STEPS.DEVICE_INSTALLATION, ts: instTs };
      setIsDeviceInstalled(!!instTs);
    }
    if ((relayStat || relayStat === 0) && relayTs) {
      installationStatusRef.current[DEV_INSTALLATION_STEPS.IMMOBILISATION_TEST] = { stat: DEV_INSTALLATION_STEPS.IMMOBILISATION_TEST, ts: relayTs };
      setIsRelayTested(!!((relayStat || relayStat === 0) && relayTs));
    }
    if (ptStat === PING_TEST_STATUS_VAL["Tested"] && ptTs) {
      installationStatusRef.current[DEV_INSTALLATION_STEPS.PING_TEST] = { stat: DEV_INSTALLATION_STEPS.PING_TEST, ts: ptTs };
      setIsPingTested(!!(ptStat === PING_TEST_STATUS_VAL["Tested"] && ptTs));
    }

    if (mapTs || instTs || (relayStat && relayTs) || (ptStat === PING_TEST_STATUS_VAL["Tested"] && ptTs)) {
      setInstTimelineHasData(true);
    }

  },[ installationDetails ]);

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.ORDER_STATUS_UPDATED, onOrderStatusUpdate);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.ORDER_STATUS_UPDATED, onOrderStatusUpdate);
    };
  }, [])

  const renderShipmentInfo = () => {
    return <div className="shipment-info-row">
      <p><span className="key">Shipment ID:</span><span className="value">{shipmentDetails.orderId ? shipmentDetails.orderId : "-"}</span></p>
      <p><span className="key">Quantity:</span><span className="value">{shipmentDetails.devcnt ? shipmentDetails.devcnt : "-"}</span></p>
      {DESIGNATION === SELLER_DES ? <p><span className="key">Dealer:</span><span className="value">{shipmentDetails.dnm ? shipmentDetails.dnm : "-"}</span></p> : ""}
    </div>
  }


  const renderShipmentTimeLinePoints = () => {
    let isCancelled = !!shipmentStatusRef.current[SHIPMENT_STATUS_CANCELLED];
    let SHIPMENT_CONSTANTS = SHIPMENT_STATUSES.filter(status => isCancelled ? status.includeInCancelTimeline : !status.cancel);

    return SHIPMENT_CONSTANTS.map((status, idx) => {
       let details = shipmentStatusRef.current[status.idx] || { stat: status.idx };

       const isCompleted = !!details.ts;
       const isStepComplete = shipmentStatusRef.current[status.idx + 1] && shipmentStatusRef.current[status.idx + 1].ts;
       let showLine = (!isCancelled || (isCancelled && SHIPMENT_CONSTANTS.length - 1 !== idx));

       return (
       <div key={idx} className={`timeline-point ${details.rnm ? "shipment-point" : ""}`}>
         <p className={`point-status ${isCompleted ? "" : "shipment-point"}`}>{SHIPMENT_STATUSES_VAL[details.stat].label}</p>
         {isCompleted && (
           <div className="timeline-point-ts">
             <p>{getLocalisedDate(details.ts, true)}</p>
             <p>{getLocalisedTime(details.ts, true, true)}</p>
             {details.rnm && <p>Received by: <span>{details.rnm}</span></p>}
           </div>
         )}

         {showLine && idx !== (SHIPMENT_CONSTANTS.length - 1) && (
           <div className={`timeline-dashed-line ${isCancelled ? "update-line-width" : ""} ${isShipmentOverviewPage && "new-width"} ${isStepComplete ? "update-border-color" : ""}`}></div>
         )}

         {isCompleted ? ( <VerifiedIcon className="verified-icon" /> ) : ( <span className="timeline-bullet"></span> )}
       </div>)
    })
 }

  const renderOrderDetails = () => {
    return orderDetailKeysAndLabels.map(detail => (
      <p className="order-dets-text" key={detail.key}>
        {detail.label}: <span>{detail.nestedKey ? (orderDetails[detail.key]?.[detail.nestedKey] || "-") : (orderDetails[detail.key] || "")}</span>
      </p>
    ));
  };

  const handlePiInvoiceDownload = () => {
    if (orderDetails.pfInvNm) {
      var link = document.createElement("a");
      link.href = INV_PREFIX.current + "/" + encodeURIComponent(orderDetails.pfInvNm);
      link.style = "visibility:hidden";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  const renderTimelinePoints = () => {
    const nextValidStatusIndices = [];
    let nextValidIdx = null;

    for (let i = ORDER_TIMELINE_STATUSES.length - 1; i >= 0; i--) {
      if (ORDER_TIMELINE_STATUSES[i].idx !== ORDER_STATUS_CANCELLED) {
        nextValidIdx = i;
      }
      nextValidStatusIndices[i] = nextValidIdx;
    }

    return ORDER_TIMELINE_STATUSES.map((status, idx) => {
      if (status.idx === ORDER_STATUS_CANCELLED) return null;

      let details = orderStatusesRef.current[status.idx] || { stat: status.idx };

      const isCompleted = !!details.ts;

      const nextStatusIndex = nextValidStatusIndices[idx + 1];
      const nextStatus = nextStatusIndex !== null ? ORDER_TIMELINE_STATUSES[nextStatusIndex] : null;
      const nextDetails = nextStatus ? orderStatusesRef.current[nextStatus.idx] || {} : {};
      const isStepComplete = !!nextDetails.ts;
      const previousIdx = idx - 1;
      const isDashboard = location.pathname === PATHS.DEALERS_OVERVIEW;

      return (
        <div className={`timeline-point ${isSeller && "d"} ${isCompleted ? "" : "update-text-color"}`} key={status.idx}>
          <p className="point-status">{ORDER_STATUS_VALS[details.stat].label}</p>
          {isCompleted && (
            <div className="timeline-point-ts">
              <p>{getLocalisedDate(details.ts, true)}</p>
              <p>{getLocalisedTime(details.ts, true, true)}</p>
              {details.rnm && <p>Received by: <span>{details.rnm}</span></p>}
            </div>
          )}
          {
            (INV_PREFIX.current && details.stat === ORDER_STATUS_PI_RAISED && orderDetails.pfInvNm) && (<div className="view-payment view-pi-invoice">
              <span className="timeline-interaction-button" onClick={handlePiInvoiceDownload}>
                Invoice
              </span>
            </div>)
          }
          {
            (isPiRaised && !isDashboard && !isCompleted && previousIdx === 2 && isSeller) && (
              <div className="timeline-point-btn-container">
                <Button className="timeline-btn" onClick={()=>{
                  setIsAddPaymentModalVisible(true);
                }}>Submit Payment Details</Button>
              </div>
            )
          }
          {
            isCompleted && details.stat === 3 && isPaymentDetailAvailable && (
              <div className="view-payment">
                 <span className=""
                 onClick={()=>{
                  setShowPaymentDetails(true);
                 }}
                 >
                 View Payment Details</span>
              </div>
            )
          }
          {idx !== (ORDER_TIMELINE_STATUSES.length - 1) && (
            <div className={`timeline-dashed-line ${isSeller ? "custom-width" : ""} ${isStepComplete ? "update-border-color" : ""}`}></div>
          )}
          {isCompleted ? (
            <VerifiedIcon className="verified-icon" />
          ) : (
            <span className="timeline-bullet"></span>
          )}
        </div>
      );
    });
  };

  const renderOrderInfo = () => {
    return (
      <div className="order-info-row">
        <p>Order ID: {orderDetails.orderId}</p>
        <p>Qty: {orderDetails.devcnt}</p>
      </div>
    )
  }

  const renderCancelledTimelinePoints = () => {
    return (
      <div className="cancelled-timeline">
        <div className="timeline-point">
          <p className="point-status">{ORDER_STATUS_VALS[orderDetails.os[0].stat].label}</p>
          <p className="timeline-point-ts">
            {getLocalisedDate(orderDetails.cdt, true)}, {getLocalisedTime(orderDetails.cdt, true, true)}
          </p>
          <VerifiedIcon className="verified-icon" />
        </div>

        <div className="single-dashed-line"></div>

        <div className="timeline-point">
          <p className="point-status">{ORDER_STATUS_VALS[orderDetails.os[orderDetails.os.length - 1].stat].label}</p>
          <p className="timeline-point-ts">
            {getLocalisedDate(orderDetails.os[orderDetails.os.length - 1].ts, true)}, {getLocalisedTime(orderDetails.os[orderDetails.os.length - 1].ts, true, true)}
          </p>
          <VerifiedIcon className="verified-icon" />
        </div>
      </div>
    )
  }

  const markInstallation = () => {
    const markInstallationData = { imei: imeiRef.current, inst: true };
    markInstallationComplete(markInstallationData, (err) => {
      if (err) console.error(err);
      else {
        setIsDeviceInstalled(true);
        installationStatusRef.current[DEV_INSTALLATION_STEPS.DEVICE_INSTALLATION] = { "ts": 1721045033842, "stat": 1 };
      }
    });
  }

  const renderInstallationTimelinePoints = () => {
    let highestCompletedStep = -1;
    DEVICE_INSTALLATION_TIMELINE_STATUSES.forEach((status) => {
      if (installationStatusRef.current[status.idx]?.ts) {
        highestCompletedStep = Math.max(highestCompletedStep, status.idx);
      }
    });

    return DEVICE_INSTALLATION_TIMELINE_STATUSES.map((status, idx) => {
      if ((DESIGNATION === SELLER_DES || DESIGNATION === SUBDEALERS_DES) && status.idx === RELAY_TEST_STATUS_VAL && !SHOW_RELAY_TEST_BTN) return "";

      const isCompleted = status.idx <= highestCompletedStep;
      const details = installationStatusRef.current[status.idx] || { stat: status.idx };

      let colorKey = "color";
      const color = isCompleted ? DEVICE_INSTALLATION_TIMELINE_STATUSES_VAL[details.stat][colorKey] : "#666666";

      return (
        <div className="timeline-point installation-time-line" key={idx}>
          <p className="point-status" style={{ color }}>{DEVICE_INSTALLATION_TIMELINE_STATUSES_VAL[details.stat].label}</p>
          {isCompleted && details.ts && (
            <div className="timeline-point-ts">
              <p>{getLocalisedDate(details.ts, true)}, {getLocalisedTime(details.ts, true, true)}</p>
            </div>
          )}
          {DESIGNATION === SUBDEALERS_DES && !isDeviceInstalled && details.stat === DEV_INSTALLATION_STEPS.DEVICE_INSTALLATION && !isCompleted && (
            <div className="timeline-point-btn-container">
              <Checkbox className={`checkbox ${!isBtnDisabled ? "installation-checkbox-checked" : ""}`} isChecked={!isBtnDisabled} onChange={() => setIsBtnDisabled(!isBtnDisabled)}>
                <span className="checkbox-text">Yes, I have Installed The Device</span>
              </Checkbox>
              <Button isDisabled={isBtnDisabled} className="timeline-btn" onClick={markInstallation}>Continue</Button>
            </div>
          )}
          {DESIGNATION === SUBDEALERS_DES && isDeviceInstalled && !isPingTested && details.stat === DEV_INSTALLATION_STEPS.PING_TEST && !isCompleted && (
            <div className="timeline-point-btn-container">
              <Button className="timeline-btn" onClick={() => handlePerformPingTest()}>Perform Ping Test</Button>
            </div>
          )}
          {DESIGNATION === SUBDEALERS_DES && isPingTested && !isRelayTested && details.stat === DEV_INSTALLATION_STEPS.IMMOBILISATION_TEST && !isCompleted && (
            <div className="timeline-point-btn-container">
              <Button className="timeline-btn" onClick={() => checkIfPingTestIsCompleted()}>Perform Test</Button>
            </div>
          )}
          {DESIGNATION === SUBDEALERS_DES && isPingTested && ((SHOW_RELAY_TEST_BTN && isRelayTested) || !SHOW_RELAY_TEST_BTN) && !isDeviceMapped && details.stat === DEV_INSTALLATION_STEPS.DEVICE_MAPPING && !isCompleted && (
            <div className="timeline-point-btn-container">
              <Button className="timeline-btn" onClick={() => handleMapDevice()}>Map Device</Button>
            </div>
          )}
          {idx !== (DEVICE_INSTALLATION_TIMELINE_STATUSES.length - 1) && (
            <div className={`timeline-dashed-line ${isSeller ? "custom-width" : ""} ${(isCompleted && isCompleted.ts) ? "update-border-color" : ""} ${!SHOW_RELAY_TEST_BTN ? "update-line-width" : ""}`}></div>
          )}
          {isCompleted ? <span className="installation-timeline-bullet"></span> : <span className="timeline-bullet" style={{ backgroundColor: color }}></span>}
        </div>
      );
    });
  };

  const closeHandler = () => {
    setIsAddPaymentModalVisible(false);
  }

  const onPaymentAdded = (payment) => {
    setPaymentDetails(payment);
    if(payment) setIsPaymentDetailAvailable(true);

    if(!orderDetails.orderId) return;
    const updateDetails = {stat: ORDER_STATUS_PAYMENT_DONE, ts: new Date().getTime()}
    setOrderDetails(prevOrderDetails => ({
      ...prevOrderDetails,
      os: [...prevOrderDetails.os,updateDetails],
      currentState:"Payment Done"
    }))
    orderStatusesRef.current[ORDER_STATUS_PAYMENT_DONE] = updateDetails;
    closeHandler();
  }

  const getNavigationPath = () => {
    const orderId = isShipmentTimeLine ? shipmentDetails.orderId : orderDetails.orderId;
    const idKey = isShipmentTimeLine ? "shipId" : "idx";
    const baseOverviewPath = isShipmentTimeLine ? PATHS.SHIPMENT_OVERVIEW : PATHS.DEALERS_OVERVIEW;
    const overviewPath = DESIGNATION === SELLER_DES ? baseOverviewPath : "";
    const navigatePath = `${overviewPath}${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?${idKey}=${orderId}`;

    return navigatePath;
  }

  return (
    <div className="widget-group last-order">
      <div className="last-order-widget">
        {showOrderDetails && <header className="widget-header">
          <Title variant="md" fixed>{title || "Last Order"}</Title>
        </header>}
        <div className="order-details-box">
          {(!showOrderDetails && !isOverviewPage) && <header className="widget-header order-status-header">
            {isInstallationDetails ? <Title variant="md" fixed>Installation Details</Title> : <Title variant="md" fixed>{(isShipment.current || (DESIGNATION === SUBDEALERS_DES)) ? "Shipment Status" : "Order Status"}</Title>}
          </header>}
          {!isShipmentOverviewPage && showOrderDetails && !isInstallationDetails && <div className="order-details">
            {orderDetails.orderId && renderOrderDetails()}
          </div>}
          {!isShipmentOverviewPage && isOverviewPage && !isInstallationDetails && <div className="order-details">
            {orderDetails.orderId && renderOrderInfo()}
          </div>}
          {isShipmentOverviewPage && <div className="order-details">
            {shipmentDetails && renderShipmentInfo()}
          </div>}
          <div className={`order-status-timeline ${isInstallationDetails && !isDeviceInstalled && "mb"}`}>
            <div className="timeline-points-container">
              {(orderDetails.os && orderDetails.os.length)&& !isInstallationDetails && (isCancelledOrder ? renderCancelledTimelinePoints() : renderTimelinePoints())}
              {isInstallationDetails && renderInstallationTimelinePoints()}
            </div>
          </div>
          {/* {showOrderDetails && <div className="widget-link last-order-widget-link">
            <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(`${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?idx=${orderDetails.orderId}`)}>
              View Reports
            </Button>
          </div>} */}
          <div className={`shipment-status-timeline ${!isInstallationDetails && !isDeviceInstalled && "mb"}`}>
            <div className="shipment-timeline-points-container">
              {isShipmentTimeLine && renderShipmentTimeLinePoints()}
            </div>
          </div>

          {((isOverviewPage || isShipmentOverviewPage) && (orderDetails.orderId || shipmentDetails.orderId)) && <div className="widget-link view-order-widget-link">
            <Button variant={"ghost"} onClick={() => navigate(getNavigationPath())}>
              {isShipmentOverviewPage ? "View Shipment" : "View Order"}
            </Button>
          </div>}
          {
            DESIGNATION === SUBDEALERS_DES && isInstallationDetails && !isDeviceInstalled && <div className="widget-link video-link">
              <Button variant={"ghost"} onClick={() => navigate(PATHS.INSTALLATION_VIDEO)} className="video-button">
               <VideoIcon/> Watch The Installation Video
              </Button>
            </div>
          }
          {
            isInstallationDetails && (isDeviceInstalled && (!isPingTested || !isRelayTested)) ?
            <div className="note-container">
              <p className="note">Note: Ensure vehicle is in a good network area, then turn ON the ignition.</p>
            </div> : ""
          }
        </div>
      </div>
      <AddPayment
        isOpen={isAddPaymentModalVisible}
        closeHandler = {closeHandler}
        handleAdd={onPaymentAdded}
        isOrdersAddPayment={true}
        isUploadImageVisible={true}
        orderId={orderDetails.orderId}
      />
      {orderDetails.orderId ? <PaymentDetailsModal paymentDetails={paymentDetails} showPaymentDetails={showPaymentDetails} setIsPaymentDetailAvailable={setIsPaymentDetailAvailable} onClose = {() => setShowPaymentDetails(false)} orderId={orderDetails.orderId}/> : null}
    </div>
  );
};

export default LastOrder;
